// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q4eL","footer":"styles_footer__uAuqo","passCodeTooltip":"styles_passCodeTooltip__1moBD"};